import type { AuthorizationReturnUrl } from '@gov-nx/component/common/Autorizace/Context';
import { AUTHORIZATION_CANCELLED_RETURN_URL_KEY } from '@gov-nx/component/common/Autorizace/constants';
import { useSessionStorage } from '@gov-nx/utils/web/hooks/useSessionStorage';
import { getWindowLocation } from '@gov-nx/utils/web/utils/windowLocation';

export const useAuthorizationReturnUrl = (): AuthorizationReturnUrl => {
	const storage = useSessionStorage(AUTHORIZATION_CANCELLED_RETURN_URL_KEY);

	return {
		save: () => {
			const { pathname, search, hash } = getWindowLocation();
			storage.set(pathname + search + hash);
		},
		clear: storage.remove,
	};
};
